import { useQuery } from "@tanstack/react-query";
import { getInstitutionBySlug } from "@/Services/institutions.service";

export function useInstitution(slug: string | undefined) {
  return useQuery({
    queryKey: ["institutions", slug],
    queryFn: () => getInstitutionBySlug(slug!),
    enabled: !!slug,
    staleTime: 10 * 60 * 1000,
  });
}
